export type LonLat = [number, number];

export interface GeoPoint {
  type: 'Point';
  coordinates: LonLat;
}
